import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { PublicAchievement } from "@/types/homeTypes"

export const usePublicTopOneAchievement = (id: number) => {
  return useGenericQuery<PublicAchievement>({
    keys: QUERY_KEYS.achievements.topOne(id),
    apiEndpoint: ENDPOINTS.achievements.topOne(id),
  })
}
